export default __webpack_public_path__ + "static/media/loading.b1c3d144.gif";